import { FC, ReactNode, useState } from "react";

import { Translate } from "@/app/application/Translate";
import { DeleteActionButton } from "@/shared/ui";
import { SxProps, Theme } from "@mui/material";

interface CustomDeleteButtonProps {
	disabled?: boolean;
	handleDelete: () => Promise<void>;
	loading?: boolean;
	textOverride?: ReactNode;
	sx?: SxProps<Theme>;
}
export const CustomDeleteButton: FC<CustomDeleteButtonProps> = (props) => {
	const [internalLoading, setInternalLoading] = useState(false);
	const isLoading = props.loading || internalLoading;

	return (
		<DeleteActionButton
			disabled={props.disabled}
			loading={isLoading}
			loadingText={
				<Translate String="LabDaily.Deleting">Deleting...</Translate>
			}
			onClick={() => {
				if (isLoading) {
					return;
				}
				setInternalLoading(true);
				void Promise.resolve(props.handleDelete()).finally(() => {
					setInternalLoading(false);
				});
			}}
			sx={props.sx}
		>
			{props.textOverride ?? (
				<Translate String="Training.Common.Button.Delete">Delete</Translate>
			)}
		</DeleteActionButton>
	);
};
